import { Service } from '@roc/feature-app-core';
import { SortDirection } from '@material-ui/core';

const url = {
  SIGN: '/api/v1/lender/referrals/sign',
  ADD_REFERRAL: '/api/v1/lender/referrals',
  ADD_REFERRER: '/api/v1/lender/referrals/saveReferrer',
  MY_REFERRALS: '/api/v1/lender/referrals/myReferrals',
  BORROWERS_REFERRALS: '/api/v1/lender/referrals/borrowerReferrals',
  GET_WIRING_INFO: '/api/v1/lender/referrals/wiringInfo',
  DELETE_REFERRAL: '/api/v1/lender/referrals',
  DOWNLOAD_WIRING_INFO: '/api/v1/lender/referrals/downloadSignedDocument',
  GET_REFERRER: '/api/v1/lender/referrals/referrer',
  GET_REFERRER_BORROWER: '/api/v1/lender/referrals/referrerBorrower',
  GET_CONVERSATION_SID_BY_ID: '/api/v1/lender/referrals/getConversationSidByReferrerBorrowerId',
};

export class ReferralsService extends Service {
  getMyReferrals(pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string) {
    return this.get(
      url.MY_REFERRALS,
      {pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters},
      { disableGlobalLoading: true }
    );
  }

  getBorrowerReferrals(pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string
  ) {
    return this.get(
      url.BORROWERS_REFERRALS,
      {pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters}
      ,{ disableGlobalLoading: true }
    );
  }

  sign(body: FormData) {
    return this.post(url.SIGN, body, { 'content-type': 'multipart/form-data' });
  }

  getReferralWiringInformation(userId) {
    return this.get(`${url.GET_WIRING_INFO}?userId=${userId}`);
  }

  deleteReferral(referralId: number) {
    return this.delete(url.DELETE_REFERRAL, { referralId });
  }

  addReferral(body) {
    return this.post(url.ADD_REFERRAL, body);
  }

  upsertReferrer(leadId: number, referrer: any, companyId: number, lenderId: number,ownerEmail:any,referralType:string,createBorrower:boolean) {
    const data = this.createBorrowerRequest(referrer);
    data.append("companyId", companyId.toString());
    data.append("leadId", leadId.toString());
    data.append("ownerEmail", ownerEmail);
    data.append("referralType", referralType);
    data.append("lenderId", lenderId.toString())
    data.append("createBorrower", createBorrower.toString())
    return this.post(url.ADD_REFERRER, data);
  }

  downloadWiringInfo(userId: number) {
    return this.get(
      url.DOWNLOAD_WIRING_INFO,
      { userId },
      {
        responseType: 'arraybuffer',
      }
    ).then(response => new Blob([response.data]));
  }

  getReferrer(leadId: number) {
    return this.get(url.GET_REFERRER, { leadId });
  }

  getReferrerForBorrower(borrowerId: number) {
    return this.get(url.GET_REFERRER_BORROWER, { borrowerId });
  }

  private createBorrowerRequest(referrer) {
    const data = new FormData();
    const form = {
      borrowerId: referrer.borrowerId,
      leadId: referrer.leadId,
      leadSource: referrer.leadSource,
      leadSfId: referrer.leadSfId,
      fromFaco: referrer.businessUnit === 'FACO',
      firstName: referrer.firstName,
      lastName: referrer.lastName,
      cellPhone: referrer.phone,
      emailAddress: referrer.email,
      secondaryEmailAddress: referrer.secondaryEmail,
      city: referrer.city,
      state: referrer.state,
      zipCode: referrer.zipcode,
      doNotCall: referrer.doNotCall,
      doNotEmail: referrer.doNotSendEmail,
      doNotMail: referrer.doNotMail,
      doNotSms: referrer.doNotSms,
      lastTextDate: referrer.lastTextDate,
      lastEmailDate: referrer.lastEmailDate,
      lastCallDate: referrer.lastCallDate,
    };
    data.append('referrer', this.cleanString(JSON.stringify(form)));
    data.append('type', referrer.referrerType);
    return data;
  }

  private cleanString = value => {
    // eslint-disable-next-line no-control-regex
    return value.replace(/(?![\x00-\x7F]|[äáàëéèíìöóòúùñç])./giu, '');
  };

  getConversationSid(referrerBorrowerId: number) {
    return this.get(url.GET_CONVERSATION_SID_BY_ID, { referrerBorrowerId });
  }
}
